export const HomeTitle = "Clear English Quran — Read, Listen & Search";

export const HomeDescription =
  "Read a clear, eloquent English translation of the Quran with verse-by-verse audio and search. Respectful terminology, smooth typography, and fast, mobile-friendly pages.";

export const UniversalTail =
  "Clear English Quran with verse-by-verse audio and search.";

export const BoosterTail = " Mobile-friendly.";  

export const ChapterDescriptionClauses: Record<number, string> = {
  1:  "A prayer for guidance, mercy, and the straight path.",
  2:  "Faith, worship, law, and community life under divine guidance.",
  3:  "Steadfast belief, trials, and consolation after setback and loss.",
  4:  "Justice, family law, inheritance, and protection of the vulnerable.",
  5:  "Covenants, lawful provisions, and integrity in public commitments.",
  6:  "Pure monotheism and signs in creation refuting idolatry.",
  7:  "Prophetic histories, human trial, and the summons to heed.",
  8:  "Discipline, unity, and reliance on God in conflict.",
  9:  "Sincerity, accountability, and distinguishing faith from hypocrisy.",
  10: "Prophetic missions, patience, and trust in the promised outcome.",
  11: "Perseverance through the stories of steadfast prophets.",
  12: "Providence, patience, and reconciliation through an exemplary life.",
  13: "Divine knowledge, decree, and signs that stir reflection.",
  14: "Gratitude, prayer, and steadfastness amid long struggles.",
  15: "Creation, rebellion, and the fate of persistent deniers.",
  16: "Blessings, lawful bounty, and the ethics of truthfulness.",
  17: "Night journey, moral discipline, and responsibility before God.",
  18: "Trial of faith, knowledge, wealth, and power; steadfast trust.",
  19: "Mercy, miraculous births, and devotion amidst hardship.",
  20: "Revelation as mercy; mission, patience, and reliance.",
  21: "Prophets’ prayers, answered needs, and the nearing reckoning.",
  22: "Pilgrimage, renewal of faith, and dignity through patience.",
  23: "Traits of believers, creation’s stages, and ultimate success.",
  24: "Chastity, social ethics, and light that guides hearts.",
  25: "Criterion between truth and falsehood; qualities of true servants.",
  26: "Prophets’ appeals and persistent rejection by arrogant leaders.",
  27: "Wisdom, gratitude, and recognizing signs with humility.",
  28: "Protection, exile, return, and trust in divine plan.",
  29: "Trials reveal sincerity; examples from past peoples.",
  30: "Cycles of rise and fall; signs for reflection.",
  31: "Parental counsel, gratitude, and measured, humble conduct.",
  32: "Revelation, creation, prostration, and the coming judgment.",
  33: "Alliances, trust, modesty, and exemplary conduct under pressure.",
  34: "Gratitude versus ingratitude; weigh your response to bounty.",
  35: "Praise, creation’s marvels, and sincere, steadfast worship.",
  36: "Warning with compassion; signs of resurrection and accountability.",
  37: "Ranks of angels, purified worship, and fates diverging.",
  38: "Patience under trial; justice, humility, and sincere repentance.",
  39: "Sincere devotion, turning back, and gates of mercy.",
  40: "Forgiveness and warning; a believer’s courageous testimony.",
  41: "Clarified revelation, patient calling, and ultimate peace.",
  42: "Consultation, forbearance, and trust in the Just Arbiter.",
  43: "Ornaments of life versus lasting truth and guidance.",
  44: "Warning signs, a veiling smoke, and decisive deliverance.",
  45: "Kneeling nations; reflection on signs and destiny.",
  46: "Steady preaching, dutiful gratitude, and measured endurance.",
  47: "Discernment in conflict and testing of intentions.",
  48: "Manifest victory, treaties, and honor through restraint.",
  49: "Brotherhood, ethics of speech, and respect for privacy.",
  50: "The nearness of resurrection and the certainty of recall.",
  51: "Winds that scatter; providence, hospitality, and recompense.",
  52: "The Mount’s oath; certainty of judgment and mercy.",
  53: "Verified revelation, limits observed, and ultimate return.",
  54: "The Hour draws near; truth made easy to remember.",
  55: "Which favors will you deny? Balance, bounty, and accountability.",
  56: "Inevitable sorting of destinies; recitation as remembrance.",
  57: "Measured decree, charity, and light on the path.",
  58: "Hearing the oppressed; oaths, ethics, and obedience.",
  59: "Exile of betrayers; unity, sincerity, and provision.",
  60: "Loyalty in faith with justice toward others.",
  61: "Align words and deeds; stand in disciplined ranks.",
  62: "Friday assembly, knowledge lived, and fleeting distractions.",
  63: "Hypocrisy unmasked: beware of deceptive assurances.",
  64: "Mutual loss and gain; trust and moderation.",
  65: "Divorce with dignity; provision, patience, and piety.",
  66: "Private matters, sincere repentance, and refined intention.",
  67: "Majesty over creation; reflect before return.",
  68: "Character, steadfastness, and the parable of entitlement.",
  69: "Undeniable reality; truthful message and lasting outcome.",
  70: "Ascents of patience amid greedy haste.",
  71: "Long perseverance in calling with clarity.",
  72: "Hidden beings listening; respond with pure devotion.",
  73: "Night devotion strengthens mission and resolve.",
  74: "Rise and warn; purify, endure, and prioritize.",
  75: "Resurrection certain; conscience stirred and guided.",
  76: "Giving for God’s sake; patience, honor, and reward.",
  77: "Messengers sent in succession; truth unfolds inevitably.",
  78: "Great announcement: creation, balance, and final judgment.",
  79: "Forcible extractors; signs, arrogance, and admonition.",
  80: "Attend carefully to seekers; measure attentiveness justly.",
  81: "Cosmic unraveling; testimony affirms trustworthy revelation.",
  82: "Rending sky; records displayed, justice completed.",
  83: "Shortchanging condemned; records sealed and distinct.",
  84: "Split sky; human toil presented and weighed.",
  85: "Persecution recorded; steadfast believers ultimately vindicated.",
  86: "Piercing star; guarded messages and purpose.",
  87: "Most High: creation, calibration, and gentle reminder.",
  88: "Overwhelming event; contrasting destinies and signs.",
  89: "Dawn’s oaths; past peoples and moral aftermath.",
  90: "A challenging city; the moral climb through compassion.",
  91: "Sun’s oaths; purify the soul to prosper.",
  92: "Diverging paths; generosity uplifts, greed burdens.",
  93: "Consolation after pause; blessings remembered gratefully.",
  94: "Expanded heart; burdens lifted and hope renewed.",
  95: "Sacred origins; mankind honored, yet accountable.",
  96: "Read in God’s name; humble the tyrant.",
  97: "Night of Decree; abundant peace and destiny.",
  98: "Clear proof; sincere worship purified from division.",
  99: "Earth speaks; deeds displayed with precision.",
  100: "Charging steeds; ingratitude exposed by urgency.",
  101: "Striking calamity; scales reveal true weight.",
  102: "Rivalry distracts; remembrance restores perspective.",
  103: "Time witnesses: faith, truth, and patience.",
  104: "Slandering hoarder; ruin from obsessive greed.",
  105: "Protected sanctuary; arrogance crushed decisively.",
  106: "Winter-summer journeys; worship the Lord of security.",
  107: "Small kindnesses neglected betray hollow worship.",
  108: "Abundant good; devote and remain steadfast.",
  109: "Clear dissociation; you your way, me mine.",
  110: "Help arrives; glorify and seek forgiveness.",
  111: "Malicious opposition meets fitting downfall.",
  112: "Absolute oneness; none comparable in essence.",
  113: "Seek refuge from every creeping harm.",
  114: "Seek refuge from whispering within men."
};

/** Build the standardized page title you like. */
export function buildTitle(nameTrans: string, chapterNumber: number, nameEnglish: string) {
  return `Surah ${nameTrans} (${chapterNumber}) – ${nameEnglish} | Clear English Quran`;
}

/** Clamp to ~155 chars (word boundary) with ellipsis. */
export function clampSnippet(s: string, limit = 155) {
  if (s.length <= limit) return s;
  const cut = s.slice(0, limit);
  const lastSpace = cut.lastIndexOf(" ");
  return (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd() + "…";
}
